import { lazy } from 'react';

type ComponentImportType = () => Promise<{
  default: React.FunctionComponent<any>;
}>;

const sessionKey = 'lazyWithRetry';

export const lazyWithRetry = (componentImport: ComponentImportType) => {
  // A chunk that resolves without its component (seen on a flaky connection in
  // Safari) makes React crash with "Element type is invalid", so treat it as a
  // failed load and retry instead.
  const load = async () => {
    const module = await componentImport();
    if (!module?.default) {
      throw new Error('Lazy module resolved without a default export', {
        cause: Object.keys(module ?? {}),
      });
    }
    return module;
  };

  const component = lazy(async () => {
    const hasRefreshed =
      globalThis.sessionStorage.getItem(sessionKey) || 'false';

    try {
      globalThis.sessionStorage.setItem(sessionKey, 'false');
      return await load();
    } catch (_error: any) {
      if (hasRefreshed === 'false') {
        globalThis.sessionStorage.setItem(sessionKey, 'true');
        globalThis.location.reload();
      }

      if (hasRefreshed === 'true') throw new Error('chunkLoadError');
    }
    return await load();
  });

  // Starts the download without rendering, for idle prefetching.
  return Object.assign(component, { preload: componentImport });
};
